// extracted by mini-css-extract-plugin
export default {"video":"Video_video__uQITI","qmeta":"Video_qmeta__k9xVf"};